import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 世界服重载
const worldReloadAll = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.world_reload_all + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

// 世界服全部重载
const worldReloadConfig = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.world_reload_config + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

// 网关链接重载
const reloadConnect = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.world_reload_connect + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

const getTableName = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.world_get_table_name + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

const clearSettingCache = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.world_cache_clear_setting + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

const getCacheValue = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.world_cache_val + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    worldReloadAll,
    worldReloadConfig,
    reloadConnect,
    getTableName,
    clearSettingCache,
    getCacheValue
}



// WEBPACK FOOTER //
// ./src/service/world_api.js